module.exports = __webpack_public_path__ + "static/img/5.20c5c03.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/5.jpg
// module id = A/ko
// module chunks = 25